export const stringify = file => {
  return `data:${file.type};base64,${file.content}`;
};



// WEBPACK FOOTER //
// ./src/app/helpers/datauri.js